import { Injectable } from '@angular/core';
import { NativeDateAdapter, MatDateFormats } from '@angular/material/core';

const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: string | object): string {
    if (displayFormat === 'input') {
      const day = date.getDate().toString().padStart(2, '0');
      const month = MONTH_NAMES[date.getMonth()];
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return date.toDateString();
  }

  override parse(value: string): Date | null {
    if (!value) return null;

    const parts = value.split('/');
    if (parts.length === 3) {
      const day = Number.parseInt(parts[0], 10);
      const monthIndex = MONTH_NAMES.findIndex(
        (m) => m.toLowerCase() === parts[1].toLowerCase(),
      );
      const year = Number.parseInt(parts[2], 10);

      if (!Number.isNaN(day) && monthIndex !== -1 && !Number.isNaN(year)) {
        return new Date(year, monthIndex, day);
      }
    }

    return super.parse(value);
  }
}

export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'input',
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Injectable({ providedIn: 'root' })
export class DateService {
  calculateMinBusinessDate(businessDays: number = 2): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let counted = 0;
    const checkDate = new Date(today);

    while (counted < businessDays) {
      checkDate.setDate(checkDate.getDate() + 1);
      const dayOfWeek = checkDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        counted++;
      }
    }

    return new Date(checkDate.getFullYear(), checkDate.getMonth(), checkDate.getDate());
  }

  createWeekdayFilter(minDate: Date): (date: Date | null) => boolean {
    return (date: Date | null): boolean => {
      if (!date) return false;
      const day = date.getDay();
      if (day === 0 || day === 6) return false;
      return date >= minDate;
    };
  }

  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  toISOStringOrEmpty(date: Date | null | undefined): string {
    return date ? date.toISOString() : '';
  }
}
